(function () {
    'use strict';

    var serviceId = 'notifierSvc';

    var defaults = {
        source: "app",
        title: "",
        message: "",
        detail: "",
        type: "info",
        hideDuration: 5000,
    };

    angular.module('app.core')
        .factory(serviceId, [notifierSvc]);

    function notifierSvc() {
        var service = {
            show: show,
            clear: clear,
            remove: remove,
            verbose: true
        };

        return service;

        function remove() {
            toastr.remove();
        }

        function clear() {
            toastr.clear();
        }
        function show(options) {
            var opns = angular.copy(defaults);

            if (typeof options === "string") {
                opns.message = options;
            } else {
                opns = angular.extend(opns, options);
            }

            if (service.verbose && opns.detail.length > 0) {
                opns.message += " " + opns.detail;
            }

            toastr[opns.type](opns.message, opns.title);
        }
    }
})();